// Generic boolean status marker — green check / red cross (moved 25.09.2026
// from ParticipantsDialog.tsx when that dialog was removed; used by the
// Abrechnung's Nachpflege table and FinancialSupportListPage).

import { Check, X } from 'lucide-react';

export function StatusMark({ value, label }: { value: boolean; label: string }) {
  return (
    <span className="inline-flex" title={label} aria-label={label}>
      {value ? (
        <Check className="h-4 w-4 text-green-600" aria-hidden />
      ) : (
        <X className="h-4 w-4 text-red-600" aria-hidden />
      )}
    </span>
  );
}
